import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const withAuth = (WrappedComponent) => {
  const AuthenticatedComponent = (props) => {
    const navigate = useNavigate();

    useEffect(() => {
      const checkAuth = async () => {
        console.log('sending request to /api/customers/authentication')
        try {
          const response = await fetch(process.env.REACT_APP_API_URL+'/api/customers/authentication', {
            method: 'GET',
            credentials: 'include'
          });
          const res = await response.json();
          console.log('response: '+res)
          if (!response.ok) {
            console.log('respsone not ok');
            navigate('/crm', { state: { message: 'Incorrect Password' } });        
        }
        } catch (error) {
          console.error('Access denied:', error);
          navigate('/crm', { state: { message: 'Unauthorized, please login again' } });        }
      };

      checkAuth();
    }, [navigate]);

    return <WrappedComponent {...props} />;
  };

  return AuthenticatedComponent;
};

export default withAuth;
